import { Outlet, useNavigate } from 'react-router-dom'
import { Activity, Bot, LogOut, Shield } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { masterService } from '@/services/masterService'
import { Button } from '@/components/ui/Button'

export function MasterLayout() {
  const navigate = useNavigate()
  const name = localStorage.getItem('master_name') || 'Super Admin'

  const handleLogout = async () => {
    await masterService.logout()
    navigate('/master/login', { replace: true })
  }

  return (
    <div className="flex min-h-screen flex-col bg-surface-950">
      <header className="border-b border-master-800 bg-master-900 px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-master-800">
            <Shield className="h-4 w-4 text-amber-400" />
          </div>
          <div>
            <span className="text-sm font-semibold text-master-50">Master Admin</span>
            <span className="ml-2 text-xs text-master-400">{name}</span>
          </div>
        </div>
        <Button variant="ghost" size="sm" className="text-master-300 hover:text-white" onClick={handleLogout}>
          <LogOut className="h-4 w-4" />
        </Button>
      </header>
      <nav aria-label="Navegación Master" className="flex gap-2 border-b border-master-800 bg-master-950 px-6 py-2">
        <NavLink to="/master/dashboard" className="rounded-lg px-3 py-2 text-sm text-master-300 hover:bg-master-800 hover:text-white">Panel</NavLink>
        <NavLink to="/master/messaging" className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-master-300 hover:bg-master-800 hover:text-white"><Bot className="h-4 w-4" aria-hidden="true" />KAFI Bot</NavLink>
        <NavLink to="/master/kafi" className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-master-300 hover:bg-master-800 hover:text-white"><Activity className="h-4 w-4" aria-hidden="true" />Observabilidad</NavLink>
        <NavLink to="/master/kafi/operations" className="rounded-lg px-3 py-2 text-sm text-master-300 hover:bg-master-800 hover:text-white">Operaciones</NavLink>
      </nav>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}
